'use strict';

export default {
  library: {
    dateRangeField: {
      action: {
        hide: 'Add A Date Range',
        show: 'Cancel',
      },
    },
    productsField: {
      product: 'Product',
      quantity: 'Qty',
      price: 'Price',
      subtotal: 'Subtotal',
    },
  },
};
